import { render, staticRenderFns } from "./BatchUpdateModal.vue?vue&type=template&id=1a61f1f6&scoped=true"
import script from "./BatchUpdateModal.vue?vue&type=script&lang=js"
export * from "./BatchUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./BatchUpdateModal.vue?vue&type=style&index=0&id=1a61f1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61f1f6",
  null
  
)

export default component.exports